// gloss
export const CUSTOM_FIELD_TARGET_MODELS = {
  FanUsers: 'FanUsers',
  Opportunity: 'Opportunity',
  BrandReferenceRequest: 'BrandReferenceRequest',
} as const;

export type CustomFieldTargetModel = (typeof CUSTOM_FIELD_TARGET_MODELS)[keyof typeof CUSTOM_FIELD_TARGET_MODELS];

export const DEFAULT_CUSTOM_FIELD_TARGET_MODEL: CustomFieldTargetModel = CUSTOM_FIELD_TARGET_MODELS.FanUsers;

export const CUSTOM_FIELD_TARGET_MODEL_VALUES = Object.values(
  CUSTOM_FIELD_TARGET_MODELS,
) as readonly CustomFieldTargetModel[];

// gloss
export const CUSTOM_FIELD_TARGET_MODEL_ALIASES: Readonly<Record<string, CustomFieldTargetModel>> = {
  fanuser: CUSTOM_FIELD_TARGET_MODELS.FanUsers,
  fanusers: CUSTOM_FIELD_TARGET_MODELS.FanUsers,
  opportunity: CUSTOM_FIELD_TARGET_MODELS.Opportunity,
  referencerequest: CUSTOM_FIELD_TARGET_MODELS.BrandReferenceRequest,
  brandreferencerequest: CUSTOM_FIELD_TARGET_MODELS.BrandReferenceRequest,
};

// gloss
const LEGACY_BY_CANONICAL: Record<CustomFieldTargetModel, string> = {
  FanUsers: 'fanUser',
  Opportunity: 'opportunity',
  BrandReferenceRequest: 'referenceRequest',
};

// gloss
export const toCanonicalTargetModel = (value: string | null | undefined): CustomFieldTargetModel | null => {
  const key = value?.trim().toLowerCase();

  return key && Object.hasOwn(CUSTOM_FIELD_TARGET_MODEL_ALIASES, key)
    ? (CUSTOM_FIELD_TARGET_MODEL_ALIASES[key] ?? null)
    : null;
};

export const isCustomFieldTargetModel = (value: string | null | undefined): value is CustomFieldTargetModel =>
  value != null && (CUSTOM_FIELD_TARGET_MODEL_VALUES as readonly string[]).includes(value);

// gloss
export const toLegacyTargetModel = (value: string | null | undefined): string | null => {
  const canonical = toCanonicalTargetModel(value);

  return canonical ? LEGACY_BY_CANONICAL[canonical] : (value ?? null);
};
